//App.js

import React, { useState, useEffect, useRef } from 'react';
// import '../style.css';

function Captcha({placeholder, styles, length, textColor1, textColor2, initialSpace, fontSize, fontFamily, canvasContainerStyle, buttonStyle, canvasStyle, canvasHeight, canvasWidth, inputStyle}) {
    const [captchaText, setCaptchaText] = useState('');
    const [userInput, setUserInput] = useState('');
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        initializeCaptcha(ctx);
    }, []);

    const generateRandomChar = (min, max) =>
        String.fromCharCode(Math.floor
            (Math.random() * (max - min + 1) + min));

    const generateCaptchaText = () => {
        let captcha = '';
        for (let i = 0; i < length/3; i++) {
            captcha += generateRandomChar(65, 90);
            captcha += generateRandomChar(97, 122);
            captcha += generateRandomChar(48, 57);
        }
        return captcha.split('').sort(
            () => Math.random() - 0.5).join('');
    };

    const drawCaptchaOnCanvas = (ctx, captcha) => {
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        const textColors = [textColor1, textColor2];
        const letterSpace = 150 / captcha.length;
        for (let i = 0; i < captcha.length; i++) {
            const xInitialSpace = initialSpace;
            ctx.font = fontSize + " " + fontFamily;
            ctx.fillStyle = textColors[Math.floor(
                Math.random() * 2)];
            ctx.fillText(
                captcha[i],
                xInitialSpace + i * letterSpace,

                // Randomize Y position slightly
                Math.floor(Math.random() * 16 + 25),
                100
            );
        }
    };

    const initializeCaptcha = (ctx) => {
        setUserInput('');
        const newCaptcha = generateCaptchaText();
        setCaptchaText(newCaptcha);
        drawCaptchaOnCanvas(ctx, newCaptcha);
    };

    const handleUserInputChange = (e) => {
        setUserInput(e.target.value);
    };

    return (
        <div style={styles}>

            <div style={canvasContainerStyle}>
                <canvas
                    ref={canvasRef}
                    width={canvasWidth}
                    height={canvasHeight}
                    style={canvasStyle}
                ></canvas>
                <button
                    type='reset'
                    style={buttonStyle}
                    onClick={() => initializeCaptcha(canvasRef.current.getContext('2d'))}>
                    <i
                        style={{ color: "#fff" }}
                        className="fa-solid fa-arrows-rotate"
                    />
                </button>
            </div>
            <input
                type="text"
                style={inputStyle}
                placeholder={placeholder}
                value={userInput}
                onChange={handleUserInputChange}
            />


        </div>
    );
}

export default Captcha;
